
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  PredictCategoryRequest,
  PredictCategoryResource,
  ProfileFamilyResource,
} from '../models';
import {
    PredictCategoryRequestFromJSON,
    PredictCategoryRequestToJSON,
    PredictCategoryResourceFromJSON,
    PredictCategoryResourceToJSON,
    ProfileFamilyResourceFromJSON,
    ProfileFamilyResourceToJSON,
} from '../models';

export interface SuggestCategoriesRequest {
    predictCategoryRequest: PredictCategoryRequest;
}

/**
 * 
 */
export class PublicProfileCategorizationApi extends runtime.BaseAPI {

    /**
     * Provides all families available with categories associated
          */
    async allFamiliesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ProfileFamilyResource>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ProfileFamilyResource>>({
            path: `/profile/public-api/families`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ProfileFamilyResourceFromJSON);
        return response;
    }

    /**
     * Provides all families available with categories associated
          */
    async allFamilies(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ProfileFamilyResource>> {
        const response = await this.allFamiliesRaw(initOverrides);
        return response._data;
    }

    /**
     * Suggest categories according to the headline
          */
    async suggestCategoriesRaw(requestParameters: SuggestCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<PredictCategoryResource>>> {
        if (requestParameters['predictCategoryRequest'] == null) {
            throw new runtime.RequiredError(
                'predictCategoryRequest',
                'Required parameter "predictCategoryRequest" was null or undefined when calling suggestCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<Array<PredictCategoryResource>>({
            path: `/profile/public-api/categories/predict`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PredictCategoryRequestToJSON(requestParameters['predictCategoryRequest']),
        }, initOverrides);

        response._data=response._data?.map(PredictCategoryResourceFromJSON);
        return response;
    }

    /**
     * Suggest categories according to the headline
          */
    async suggestCategories(requestParameters: SuggestCategoriesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<PredictCategoryResource>> {
        const response = await this.suggestCategoriesRaw(requestParameters, initOverrides);
        return response._data;
    }

}
